/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachment,
    ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachmentFromJSON,
    ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachmentFromJSONTyped,
    ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem
 */
export interface ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem {
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem
     */
    subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem
     */
    alert_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem
     */
    alert_submitted_by?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem
     */
    direction?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem
     */
    gxs_alert_id?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachment>}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem
     */
    attachments?: Array<ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachment> | null;
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItemFromJSON(json: any): ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem {
    return ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'alert_type': !exists(json, 'alert_type') ? undefined : json['alert_type'],
        'alert_submitted_by': !exists(json, 'alert_submitted_by') ? undefined : json['alert_submitted_by'],
        'direction': !exists(json, 'direction') ? undefined : json['direction'],
        'gxs_alert_id': !exists(json, 'gxs_alert_id') ? undefined : json['gxs_alert_id'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachmentFromJSON)),
    };
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItemToJSON(value?: ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'subject': value.subject,
        'message': value.message,
        'alert_type': value.alert_type,
        'alert_submitted_by': value.alert_submitted_by,
        'direction': value.direction,
        'gxs_alert_id': value.gxs_alert_id,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(ControlcenterMelcoControlCenterModelsDigitizingOrderAlertAttachmentToJSON)),
    };
}


